export class TranslationTextView {
    public no: number;
    public mediaId: string;
    public mediaName: string;
    public mediaTypeCode: string;
    public mediaTypeName: string;
    public text: string;
}